// @flow

import type { DashboardState } from "./types";

export const initialState: DashboardState = {
  error: null,
  requestsInProgress: 0,
  absenceNow: {
    departmentOverview: [],
    reasonOverview: [],
    trendActivity: [],
    effectiveParameters: null,
    requestsInProgress: 0,
  },
  overview: {
    notificationReviews: [],
    statistics: [],
    today: [],
    targetedReasons: null,
    requestsInProgress: 0,
  },
  activityFeed: [],
  recentActivity: [],
  firstcareIndexPageStatistic: {
    aboveAverageMeasures: 0,
    absenceLevels: [],
    absenceReasons: [],
    ageGroups: [],
    belowAverageMeasures: 0,
    equalToAverageMeasures: 0,
    genders: [],
    staffGroups: [],
    totalAverages: 0,
    weekdays: [],
  },
  absenceNotes: [],
  hierarchyBreakdown: {
    content: [],
    requestsInProgress: 0,
  },
};

export default initialState;
